import React, { useEffect, useState } from "react";
import { Container, Button, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchOrderStatus } from "../../lib/store";
import "./OrderSuccessPage.css";

function useQuery() {
  const { search } = useLocation();
  return new URLSearchParams(search);
}

  function ga4Purchase({ transaction_id, value, currency, email }) {
  if (!window.gtag) return;

  window.gtag("event", "purchase", {
    transaction_id,
    value,
    currency: currency || "USD",
    // optional extras
    user_email: email,
  });
}

const OrderSuccessPage = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const sessionId = query.get("session_id");

  const [loading, setLoading] = useState(!!sessionId);
  const [error, setError] = useState("");
  const [order, setOrder] = useState(null);





  useEffect(() => {
    if (!sessionId) return;

    let isMounted = true;

    (async () => {
      try {
        const data = await fetchOrderStatus(sessionId);
        if (!isMounted) return;
        setOrder(data);
        setError("");
      } catch (err) {
        console.error(err);
        if (!isMounted) return;
        setError("We had trouble confirming your order.");
      } finally {
        if (isMounted) setLoading(false);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [sessionId]);

useEffect(() => {
  if (!order) return;

  const paid =
    order.status === "paid" || order.paymentIntentStatus === "succeeded";
  if (!paid) return;

  const key = `ga4_purchase_fired_${sessionId || "no_session"}`;
  if (sessionStorage.getItem(key)) return;

  const value =
    typeof order.amountTotal === "number" ? order.amountTotal / 100 : undefined;

  if (window.gtag) {
    window.gtag("event", "purchase", {
      transaction_id: order.id || sessionId || `lpp_${Date.now()}`,
      value,
      currency: order.currency || "USD",
    });
  }

  sessionStorage.setItem(key, "1");
}, [order, sessionId]);



  const amountFormatted =
    order && typeof order.amountTotal === "number"
      ? `$${(order.amountTotal / 100).toFixed(2)}`
      : null;

  const isPaid =
    order &&
    (order.status === "paid" || order.paymentIntentStatus === "succeeded");

  return (
    <div className="order-success-wrapper">
      <Container className="order-success-inner">
        <div className="order-success-card">
          <div className="order-success-icon-wrap">
            <span className="order-success-icon">🐾</span>
          </div>

          {!sessionId && (
            <>
              <h1 className="order-success-title">Order received</h1>
              <p className="order-success-text">
                We couldn&apos;t find a Stripe session ID in your link, but if
                you completed a purchase, your SmartTag order is being
                processed.
              </p>
            </>
          )}

          {sessionId && loading && (
            <>
              <h1 className="order-success-title">Confirming your order…</h1>
              <p className="order-success-text">
                We&apos;re verifying your SmartTag purchase with Stripe.
              </p>
              <Spinner animation="border" role="status" size="sm" className="mt-3">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </>
          )}

          {sessionId && !loading && error && (
            <>
              <h1 className="order-success-title">Order confirmed</h1>
              <p className="order-success-text">
                Your SmartTag order was processed, but we couldn&apos;t load all
                the details right now. If you have any questions, please contact
                support.
              </p>
            </>
          )}

          {sessionId && !loading && order && (
            <>
              <h1 className="order-success-title">
                {isPaid ? "Thank you for your order!" : "Order received"}
              </h1>
              <p className="order-success-subtitle">
                Your Little Paws Place SmartTag is on its way.
              </p>

              {amountFormatted && (
                <p className="order-success-amount">
                  <span>Order total:</span> <strong>{amountFormatted}</strong>
                </p>
              )}

              {order.email && (
                <p className="order-success-text">
                  We&apos;ve sent a receipt to{" "}
                  <strong>{order.email}</strong>.
                </p>
              )}

              <p className="order-success-text">
  <strong>Next step:</strong> When your SmartTag arrives, you’ll use the LP ID on
  the tag (example: <strong>LP1001</strong>) to activate your profile and unlock
  features like Feeding Plans and the Paw Assistant.
</p>

<ul className="order-success-steps">
  <li>Wait for delivery (shipping confirmation will be sent)</li>
  <li>Find the LP ID printed on your SmartTag</li>
  <li>Go to SmartTag Activation and enter the LP ID</li>
</ul>

            </>
          )}

          <div className="order-success-actions">
          <Button
  variant="primary"
  onClick={() => navigate("/smarttag")}
  className="order-success-btn"
>
  Activation instructions (after delivery)
</Button>

            <Button
              variant="outline-light"
              onClick={() => navigate("/")}
              className="order-success-btn-secondary"
            >
              Back to home
            </Button>
          </div>

          <p className="order-success-footnote">
            Need help with your order?{" "}
            <button
              type="button"
              className="order-success-link"
              onClick={() => navigate("/contact-support")}
            >
              Contact support
            </button>
            .
          </p>
        </div>
      </Container>
    </div>
  );
};

export default OrderSuccessPage;
